module.exports = __webpack_public_path__ + "img/logo-onix.4131e0cf.png";